import { render, staticRenderFns } from "./authTips.vue?vue&type=template&id=5e002d1e&scoped=true&"
import script from "./authTips.vue?vue&type=script&lang=js&"
export * from "./authTips.vue?vue&type=script&lang=js&"
import style0 from "./authTips.vue?vue&type=style&index=0&id=5e002d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e002d1e",
  null
  
)

export default component.exports